# Terms of Service for Safe Learning Management System

## 1\. Introduction

These Terms of Service ("Terms") govern your access to and use of the Safe Learning Management System ("Service") provided by Safe Asset Group International AB ("we," "us," or "our"). By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the Terms, you may not access the Service.

## 2\. Changes to Terms

We reserve the right to modify or replace these Terms at any time. We will provide notice of any significant changes by posting the new Terms on this page. Your continued use of the Service after any such changes constitutes your acceptance of the new Terms.

## 3\. Access to the Service

3.1. The Service is available only to users who have been provided with course codes or have been granted access to the Service Administrative Portal.

3.2. You are responsible for maintaining the confidentiality of your course codes and account credentials, and for all activities that occur under your account.

## 4\. User Conduct

You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to:

4.1. Use the Service in any way that violates any applicable local, national, or international law or regulation.

4.2. Attempt to gain unauthorised access to any portion of the Service or any other systems or networks connected to the Service.

4.3. Use the Service to transmit any data or send or upload any material that contains viruses, Trojan horses, worms, time-bombs, keystroke loggers, spyware, adware, or any other harmful programs or similar computer code designed to adversely affect the operation of any computer software or hardware.

4.4. Use any robot, spider, or other automatic device, process, or means to access the Service for any purpose, including monitoring or copying any of the material on the Service.

## 5\. Intellectual Property Rights

5.1. The Service and its original content, features, and functionality are and will remain the exclusive property of Safe Asset Group International AB and its licensors.

5.2. You are granted a limited licence to access and use the Service and to download and print course materials for your personal, non-commercial use.

## 6\. User Content

6.1. You retain any and all of your rights to any content you submit, post, or display on or through the Service ("User Content").

6.2. By posting User Content, you grant us the right and licence to use, modify, publicly perform, publicly display, reproduce, and distribute such User Content on and through the Service.

## 7\. Termination

7.1. We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.

7.2. Upon termination, your right to use the Service will immediately cease.

## 8\. Limitation of Liability

8.1. In no event shall Safe Asset Group International AB, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.

## 9\. Disclaimer

9.1. Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis.

9.2. We do not warrant that the Service will be uninterrupted, timely, secure, or error-free.

## 10\. Governing Law

These Terms shall be governed and construed in accordance with the laws of Sweden, without regard to its conflict of law provisions.

## 11\. Changes to the Service

We reserve the right to withdraw or amend the Service, and any service or material we provide via the Service, in our sole discretion without notice. We will not be liable if for any reason all or any part of the Service is unavailable at any time or for any period.

## 12\. Contact Us

If you have any questions about these Terms, please contact us at:

Safe Asset Group International AB  
Kivra: 559072-8746  
106 31 Stockholm  
Sweden

Email: [info@safeassetgroup.com](mailto:info@safeassetgroup.com)  
Phone: \+46 31 201 000

Last updated: 2024-09-05
